<template lang="pug">
  .component-vehicle-status(v-if="item")
    .row.align-middle.align-center(v-if="showToolTip")
      tooltip(v-if="odometer", :open="true", :position="'right'", :tip="`Odometer: ${item.odometer}${configuration.locale.locale_distance_unit.value}`").has-tip
        span.fa.fa-dashboard.fa-lg
        span.label.fuelStatus {{item.odometer}}{{configuration.locale.locale_distance_unit.value}}
      tooltip(:open="true", :position="'right'", :tip="'Fuel type: '+item.fuel_type").has-tip
        span.fa.fa-bolt.fa-lg(:class="fuelLevel()")
        span.label.fuelStatus {{fuelStatus()}}
      tooltip(:open="true", :position="'right'", :tip="'Door: '+item.door_status").has-tip
        span(:class="doorStatus(item.door_status)")
      tooltip(:open="true", :position="'right'", :tip="'Engine: '+item.engine_status").has-tip
        span.fa.fa-car.fa-lg(:class="status(item.engine_status)")
      tooltip(:open="true", :position="'right'", :tip="item.vehicle_slot_hidden ? 'Hidden on map' : 'Visible on map'").has-tip
        span.fa.fa-lg(:class="visibility(item.vehicle_slot_hidden)")
      span.has-tip
        span.fa.fa-product-hunt.fa-lg(:class="inRange()", @click="openDetail")
    .position-detail(v-if="showDetail")
      .close-button(@click="showDetail = false") x
      GoogleMapContainer
        GoogleMap(:api-key="mapsAPI", :center="{lat:item.position.latitude,lng:item.position.longitude}", :zoom="17", :zoomControl="true")
          google-map-marker(
            :key='item.plate',
            :position="{lat: item.position.latitude, lng: item.position.longitude}",
            :title='`${item.brand} ${item.model}`',
            :label="`${item.brand} ${item.model}`")
    .row.align-middle.align-center(v-if="showToolTip === false")
      span.fa.fa-dashboard.fa-lg
      span.label.fuelStatus {{item.odometer}}{{configuration.locale.locale_distance_unit.value}}
      span.fa.fa-bolt.fa-lg(:class="fuelLevel()")
      span.label.fuelStatus {{fuelStatus()}}
      span(:class="doorStatus(item.door_status)")
      span.fa.fa-car.fa-lg(:class="status(item.engine_status)")

</template>
<script type="text/babel">
import Tooltip from 'components/structure/foundation/Tooltip'
import GoogleMap from '../../../lib/map/GoogleMap.vue'
import GoogleMapMarker from '../../../lib/map/GoogleMapMarker.vue'
import GoogleMapContainer from '../../backoffice/GoogleMapContainer'
import {mapState} from 'vuex'

export default {
  name: 'VehicleStatus',
  components: {GoogleMapContainer, Tooltip, GoogleMap, GoogleMapMarker},
  data() {
    return {
      showDetail: false
    }
  },
  created() {
  },
  methods: {
    openDetail() {
      this.showDetail = !this.showDetail
    },
    fuelStatus() {
      const fuelLevel = this.item.fuel_level === null ? ' --' : ' ' + this.item.fuel_level + '%'
      const range = this.item.range === null ? '' : `(${this.item.range}${this.configuration.locale.locale_distance_unit.value})`
      return `${fuelLevel}${range}`
    },
    fuelLevel() {

      if (this.item.fuel_level === null) {
        return 'grey-status'
      }
      if (this.item.fuel_level < 20) {
        return 'red-status'
      } else if (this.item.fuel_level >= 50 && this.item.fuel_level <= 80) {
        return 'yellow-status'
      } else if (this.item.fuel_level > 80) {
        return 'green-status'
      }
    },
    status(itemStatus) {
      switch (itemStatus) {
        case 'RUNNING':
          return 'red-status'
        case 'NOT RUNNING':
          return 'green-status'
      }
    },
    doorStatus(itemStatus) {
      switch (itemStatus) {
        case 'UNLOCKED':
          return 'door-open fa fa-unlock'
        case 'LOCKED':
          return 'door-closed fa fa-lock'
      }
    },
    visibility(hidden){
      if (hidden){
        return 'fa fa-map red-status'
      }

      return 'fa fa-map green-status'
    },
    inRange() {
      return this.item.in_range ? 'green-status' : 'red-status'
    }
  },
  computed: {
    mapsAPI: function () {
      return window.env.GOOGLE_MAPS_KEY
    },
    ...mapState({
      configuration: state => state.configuration,
    }),
  },
  props: {
    item: {type: Object},
    odometer: {type: Boolean, default: false},
    showToolTip: {type: Boolean, default: true}
  }
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component-vehicle-status

  span:not(.fuelStatus)
    margin: 4px
    font-size: 1.2rem

  .grey-status
    color: #C1C1C1

  .green-status
    color: #27803e

  .red-status
    color: red

  .yellow-status
    color: #ffc200

  .door-closed
    color: #27803e

  .door-open
    color: red

  .fa-product-hunt
    cursor: pointer

  .position-detail
    position: absolute
    top: 0
    width: 220px
    height: 220px
    padding: 3em 0.5em 0 0
    background: #fff
    z-index: 1

    .google-map
      min-width: 220px
      min-height: 220px

</style>



// WEBPACK FOOTER //
// VehicleStatus.vue?c50507e0